module.exports = __webpack_public_path__ + "img/1.3742e8ad.jpg";